export default __webpack_public_path__ + "static/media/wireframes-bg.26a8e310.svg";